import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { useStyles } from "./styles";

type FixedParameterRow = {
  id: string;
  parameterKey: string;
  weight: string;
  price: string;
  unitKey: string;
  quantity: string;
  totalWeight: string;
  totalPrice: string;
  totalPriceNis: string;
};

const fixedParameterRows: FixedParameterRow[] = [
  {
    id: "1",
    parameterKey: "QUOTES.DETAILS.FIXED_PARAMETER.ROWS.FRONT_WALL",
    weight: "202,2",
    price: "₪ 900",
    unitKey: "QUOTES.DETAILS.FIXED_PARAMETER.UNIT.UNIT",
    quantity: "1",
    totalWeight: "202,2",
    totalPrice: "₪ 900",
    totalPriceNis: "900",
  },
  {
    id: "2",
    parameterKey: "QUOTES.DETAILS.FIXED_PARAMETER.ROWS.REINFORCED_FRONT_WALL",
    weight: "0",
    price: "₪ 500",
    unitKey: "QUOTES.DETAILS.FIXED_PARAMETER.UNIT.UNIT",
    quantity: "0",
    totalWeight: "0",
    totalPrice: "₪ 0",
    totalPriceNis: "0",
  },
  {
    id: "3",
    parameterKey: "QUOTES.DETAILS.FIXED_PARAMETER.ROWS.REAR_CRANE_WALL",
    weight: "66",
    price: "₪ 370",
    unitKey: "QUOTES.DETAILS.FIXED_PARAMETER.UNIT.UNIT",
    quantity: "0",
    totalWeight: "0",
    totalPrice: "₪ 0",
    totalPriceNis: "0",
  },
  {
    id: "4",
    parameterKey: "QUOTES.DETAILS.FIXED_PARAMETER.ROWS.FLOOR_BEAM_200",
    weight: "9,34",
    price: "$0,85",
    unitKey: "QUOTES.DETAILS.FIXED_PARAMETER.UNIT.METER",
    quantity: "0",
    totalWeight: "0",
    totalPrice: "$0",
    totalPriceNis: "0",
  },
  {
    id: "5",
    parameterKey: "QUOTES.DETAILS.FIXED_PARAMETER.ROWS.FLOOR_BEAM_220",
    weight: "11,79",
    price: "$0,85",
    unitKey: "QUOTES.DETAILS.FIXED_PARAMETER.UNIT.METER",
    quantity: "2,5",
    totalWeight: "29,5",
    totalPrice: "$25,05",
    totalPriceNis: "100,22",
  },
  {
    id: "6",
    parameterKey: "QUOTES.DETAILS.FIXED_PARAMETER.ROWS.FLOOR_BEAM_250",
    weight: "13,02",
    price: "$0,85",
    unitKey: "QUOTES.DETAILS.FIXED_PARAMETER.UNIT.METER",
    quantity: "0",
    totalWeight: "0",
    totalPrice: "$0",
    totalPriceNis: "0",
  },
  {
    id: "7",
    parameterKey: "QUOTES.DETAILS.FIXED_PARAMETER.ROWS.FRONT_FLOOR_U8",
    weight: "8,64",
    price: "$1,15",
    unitKey: "QUOTES.DETAILS.FIXED_PARAMETER.UNIT.METER",
    quantity: "2,45",
    totalWeight: "21,2",
    totalPrice: "$24,34",
    totalPriceNis: "97,37",
  },
  {
    id: "8",
    parameterKey: "QUOTES.DETAILS.FIXED_PARAMETER.ROWS.FRONT_FLOOR_U10",
    weight: "10,6",
    price: "$1,15",
    unitKey: "QUOTES.DETAILS.FIXED_PARAMETER.UNIT.METER",
    quantity: "0",
    totalWeight: "0",
    totalPrice: "$0",
    totalPriceNis: "0",
  },
  {
    id: "9",
    parameterKey: "QUOTES.DETAILS.FIXED_PARAMETER.ROWS.ALUMINUM_FRONT_80_5",
    weight: "29,55",
    price: "₪ 60",
    unitKey: "QUOTES.DETAILS.FIXED_PARAMETER.UNIT.METER",
    quantity: "0",
    totalWeight: "0",
    totalPrice: "$0",
    totalPriceNis: "0",
  },
  {
    id: "10",
    parameterKey: "QUOTES.DETAILS.FIXED_PARAMETER.ROWS.REAR_ALUMINUM_80_4",
    weight: "14,4",
    price: "₪ 48",
    unitKey: "QUOTES.DETAILS.FIXED_PARAMETER.UNIT.METER",
    quantity: "0",
    totalWeight: "0",
    totalPrice: "$0",
    totalPriceNis: "0",
  },
];

const QuotesFixedParameter = () => {
  const styles = useStyles();
  const { t } = useTranslation();

  return (
    <Box className={styles.root}>
      <Typography className={styles.title}>
        {t("QUOTES.DETAILS.FIXED_PARAMETER.TITLE")}
      </Typography>

      <Box className={styles.list}>
        {fixedParameterRows.map((row) => (
          <Box className={styles.rowCard} key={row.id}>
            <Box className={styles.parameterCell}>
              <Typography className={styles.fieldLabel}>
                {t("QUOTES.DETAILS.FIXED_PARAMETER.PARAMETER")}
              </Typography>

              <Typography className={styles.parameterValue}>
                {t(row.parameterKey)}
              </Typography>
            </Box>

            <Box className={styles.valuesGrid}>
              <Box className={styles.valueCell}>
                <Typography className={styles.fieldLabel}>
                  {t("QUOTES.DETAILS.FIXED_PARAMETER.WEIGHT")}
                </Typography>
                <Typography className={styles.fieldValue}>{row.weight}</Typography>
              </Box>

              <Box className={styles.valueCell}>
                <Typography className={styles.fieldLabel}>
                  {t("QUOTES.DETAILS.FIXED_PARAMETER.PRICE")}
                </Typography>
                <Typography className={styles.fieldValue}>{row.price}</Typography>
              </Box>

              <Box className={styles.valueCell}>
                <Typography className={styles.fieldLabel}>
                  {t("QUOTES.DETAILS.FIXED_PARAMETER.UNIT_LABEL")}
                </Typography>
                <Typography className={styles.fieldValue}>
                  {t(row.unitKey)}
                </Typography>
              </Box>

              <Box className={styles.valueCell}>
                <Typography className={styles.fieldLabel}>
                  {t("QUOTES.DETAILS.FIXED_PARAMETER.QUANTITY")}
                </Typography>
                <Typography className={styles.fieldValue}>{row.quantity}</Typography>
              </Box>

              <Box className={styles.valueCell}>
                <Typography className={styles.fieldLabel}>
                  {t("QUOTES.DETAILS.FIXED_PARAMETER.TOTAL_WEIGHT")}
                </Typography>
                <Typography className={styles.greenValue}>
                  {row.totalWeight}
                </Typography>
              </Box>

              <Box className={styles.valueCell}>
                <Typography className={styles.fieldLabel}>
                  {t("QUOTES.DETAILS.FIXED_PARAMETER.TOTAL_PRICE")}
                </Typography>
                <Typography className={styles.greenValue}>
                  {row.totalPrice}
                </Typography>
              </Box>

              <Box className={styles.valueCell}>
                <Typography className={styles.fieldLabel}>
                  {t("QUOTES.DETAILS.FIXED_PARAMETER.TOTAL_PRICE_NIS")}
                </Typography>
                <Typography className={styles.greenValue}>
                  {row.totalPriceNis}
                </Typography>
              </Box>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default QuotesFixedParameter;